<template>
  <div>
    <div class="main">
      <img class="check-img" src="@/assets/check-ic.png" />
      <p class="text-line1">로그인 성공</p>
      <p class="text-line2">잠시 뒤 홈화면으로 이동합니다</p>
    </div>
  </div>
</template>

<script>
import { lgDeepLinkCheck } from "@/utils/common"

export default {
  data() {
    return {
      timer: null,
      isActiveVue: true,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  created() {
    this.timer = setTimeout(this.replaceView, 2000)
  },
  methods: {
    replaceView() {
      clearTimeout(this.timer)
      this.timer = null

      if (process.env.VUE_APP_OS_TYPE == "samsung") {
        this.$router.replace({
          name: "home",
          params: {
            t: new Date().getTime(),
          },
        });
      } else {        
        // LG DeepLink를 통해 앱 실행 시 해당 영상으로 이동 처리        
        lgDeepLinkCheck()
      }
    },
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  margin-top: 388.5px;
  text-align: center;
}
.check-img {
  width: 128px;
  height: 129px;
}
.text-line1 {
  font-size: 56px;
  line-height: 1;
  color: #eeeeee;
  margin: 40px 0;
}
.text-line2 {
  font-size: 28px;
  line-height: 1.29;
  color: #888888;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .main {
    margin-top: 0px;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
  }
  .check-img {
    width: 64px;
    height: 64px;
  }
  .text-line1 {
    font-size: 32px;
    line-height: 1;
    color: #ffffff;
    margin: 40px 0 24px;
    font-weight: bold;
  }
  .text-line2 {
    font-size: 20px;
    line-height: 1;
    color: #888888;
  }
}
</style>